import type { AppState } from 'src/reducers';
import { createSelector, type Selector } from 'reselect';
import type { BasicPivotItem } from 'src/worker/pivotWorker.types';
import { isNil } from 'lodash';

const getHistoryStylePane: Selector<AppState, BasicPivotItem[] | null> = (state) => {
  return state.historyStylePane.currentItem;
};

function processCurrentItem(item: BasicPivotItem[] | null): BasicPivotItem[] | null {
  return isNil(item) ? null : item;
}

export const getProcessedCurrentItem = createSelector(getHistoryStylePane, (currentItem) => {
  return processCurrentItem(currentItem);
});
